import React, { memo, PropsWithChildren } from 'react'
import {
  Avatar,
  Box,
  ListItemIcon,
  Menu,
  MenuItem,
  Stack,
  Typography
} from '@mui/material'
import { deepOrange } from '@mui/material/colors'
import { useAppSelector } from '@/globalStore/hooks.ts'
import Logout from '@mui/icons-material/Logout'
import useUserMenuLogic from '@/core/layouts/header/userMenu/useUserMenuLogic.ts'
import ClickAwayListener from '@/core/components/clickAwayListener/ClickAwayListener.tsx'
import { resolveUrl } from '@/core/utils/files.ts'

const UserMenu = () => {
  const { loggedUser } = useAppSelector((state) => state.global)
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const { handleOnLogout } = useUserMenuLogic()

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const CustomMenuItem = memo(
    ({ children, onClick }: PropsWithChildren & { onClick: () => void }) => (
      <ClickAwayListener onClickAway={handleClose}>
        <MenuItem onClick={onClick}>{children}</MenuItem>
      </ClickAwayListener>
    )
  )

  return (
    <React.Fragment>
      <Box
        sx={{
          p: 2,
          '&:hover': {
            cursor: 'pointer'
          }
        }}
        onClick={handleClick}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <Stack direction="row" sx={{ gap: 2 }}>
          <Avatar
            src={resolveUrl(loggedUser?.photo)}
            alt={loggedUser?.email || ''}
            sx={{ bgcolor: deepOrange[500] }}
          />
          <Stack direction="column">
            <Typography variant="subtitle2">{loggedUser?.email}</Typography>
            <Typography variant="body2" sx={{ color: '#9599AD' }}>
              {loggedUser?.roles[0]?.name}
            </Typography>
          </Stack>
        </Stack>
      </Box>
      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0
              }
            }
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <CustomMenuItem onClick={handleOnLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Salir del sistema
        </CustomMenuItem>
      </Menu>
    </React.Fragment>
  )
}

export default UserMenu
